import type { DocumentDefinition } from "@/store/documentManagementSlice";

/** 書類管理 API 未ロード時のフォールバック（専有部登録・契約更新で共有） */
export const fallbackIndividualDocs: DocumentDefinition[] = [
  {
    document_type: "ind-1",
    display_name: "賃貸借契約書",
    is_required: true,
    is_enabled: true,
    is_default: true,
    order: 1,
  },
  {
    document_type: "ind-2",
    display_name: "身分証明書",
    is_required: true,
    is_enabled: true,
    is_default: true,
    order: 2,
  },
  {
    document_type: "ind-3",
    display_name: "収入証明書",
    is_required: true,
    is_enabled: true,
    is_default: true,
    order: 3,
  },
  {
    document_type: "ind-4",
    display_name: "保証人関連書類",
    is_required: true,
    is_enabled: true,
    is_default: true,
    order: 4,
  },
];

export const fallbackCorporateDocs: DocumentDefinition[] = [
  {
    document_type: "corp-1",
    display_name: "賃貸借契約書",
    is_required: true,
    is_enabled: true,
    is_default: true,
    order: 1,
  },
  {
    document_type: "corp-2",
    display_name: "登記事項証明書",
    is_required: true,
    is_enabled: true,
    is_default: true,
    order: 2,
  },
  {
    document_type: "corp-3",
    display_name: "印鑑証明書",
    is_required: true,
    is_enabled: true,
    is_default: true,
    order: 3,
  },
  {
    document_type: "corp-4",
    display_name: "定款／会社概要",
    is_required: true,
    is_enabled: true,
    is_default: true,
    order: 4,
  },
];
